import React, { useState, useEffect, useRef } from 'react';
import './CustomSearch2.css';
import { HandySvg } from "handy-svg";
import ArrowDropDown from "./img/arrowSort.svg";
import broomstick from "./img/metla.svg"

const CustomSearch2 = (
    {
        name,
        data,
        selected,
        idSelectedItem,
        selected2,
        dropdown_wrapper_modifikator,
        dropdown_header_modifikator,
        sorted,
        clearFull,
        sendClearFilters,
        initialValue,
        initialValue2

    }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [filter, setFilter] = useState(initialValue || '');
    const [filter2, setFilter2] = useState(initialValue2 || '');
    const [selectedItem, setSelectedItem] = useState(null);
    const dropdownRef = useRef(null);
    const [sortedInSearch, setSortedInSearch] = useState(true);
    const debounceTimeout = useRef(null);

    useEffect(() => {
        setFilter(initialValue || '');
    }, [initialValue]);

    useEffect(() => {
        setFilter2(initialValue2 || '');
    }, [initialValue2]);

    useEffect(() => {
        if (clearFull === true) {
            clearValueSelect(); // Вызываем функцию очистки
            sendClearFilters(false); // Сбрасываем состояние очистки в родительском компоненте
        }
    }, [clearFull]);


    const sendData = (value) => {
        if (typeof selected === 'function') {
            selected(value); // Передаем значение родителю
        }
    };

    const sendData2 = (value) => {
        if (typeof selected2 === 'function') {
            selected2(value); // Передаем значение родителю
        }
    };

    const getId = (value) => {
        if (typeof idSelectedItem === 'function') {
            idSelectedItem(value);
        }
    }

    const toggleDropdown = () => {
        setIsOpen(prev => !prev);
    };

    const handleFilterChange = (event) => {
        const newValue = event.target.value;
        setFilter(newValue); // Сразу обновляем локальное состояние

        // Если значение полностью очищено
        if (newValue.trim() === '') {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }

            sendData(''); // Отправляем пустое значение
            getId(null); // Устанавливаем id в null
            setSelectedItem(null); // Сбрасываем выбранный элемент
            return;
        }

        let formattedDate = newValue;

        if (newValue.match(/\d{4}-\d{2}-\d{2}/)) {
            const dateParts = newValue.split('-');
            formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
        }

        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            // Ищем совпадение только если есть данные для поиска
            if (data && data.length > 0 && newValue.trim() !== '') {
                const matchingItem = data.find(item => {
                    const displayValue = typeof item === 'object' ? (item.name || item.fio || 'Неизвестно') : item;
                    return displayValue.toLowerCase().includes(newValue.toLowerCase());
                });

                if (matchingItem) {
                    const id = matchingItem.id || matchingItem.guid;
                    sendData(newValue);
                    getId(id);
                } else {
                    sendData(newValue);
                    getId(null);
                }
            } else {
                sendData(newValue);
                getId(null);
            }
        }, 300);
    };

    useEffect(() => {
        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, []);

    const handleFilterChange2 = (event) => {
        const newValue = event.target.value;
        let formattedDate = newValue;

        if (newValue.match(/\d{4}-\d{2}-\d{2}/)) {
            const dateParts = newValue.split('-');
            formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
        }
        setFilter2(newValue);

        // Если поле очищено
        if (newValue === '') {
            sendData2('');
            getId(null);
        } else {
            sendData2(formattedDate);
            getId(formattedDate.id);
        }
    };

    const handleFilterChange3 = (event) => {
        const newValue = event.target.value;
        let formattedDate = newValue;

        if (newValue.match(/\d{4}-\d{2}-\d{2}/)) {
            const dateParts = newValue.split('-');
            formattedDate = `${dateParts[2]}.${dateParts[1]}.${dateParts[0]}`;
        }
        setFilter(newValue);

        // Если поле очищено
        if (newValue === '') {
            sendData('');
            getId(null);
            setSelectedItem(null);
        } else {
            sendData(formattedDate);
            getId(formattedDate.id);
        }
    };

    const handleItemSelect = (item, index) => {
        setSelectedItem(item);
        const itemId = item.guid || item.id;
        getId(itemId);
        const itemValue = item.name ? item.name : item.fio ? item.fio : item;
        setFilter(itemValue);
        sendData(itemValue); // Передаем выбранный элемент
        setIsOpen(false);
    };

    const toggleSortOrder = (value) => {
        if (typeof sorted === 'function') {
            setSortedInSearch(!sortedInSearch)
            sorted(sortedInSearch);
        }
    };

    function clearValueSelect(){
        setFilter("");
        setFilter2("");
        sendData('');
        sendData2('');
        getId(null);
        setSelectedItem(null);
        setIsOpen(false);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const filteredData = data ? data.filter(item => {
        const displayValue = typeof item === 'object' ? (item.name || item.fio || 'Неизвестно') : item;
        return displayValue.toLowerCase().includes(filter.toLowerCase()); // Фильтрация по введенному значению
    }) : [];

    const formatDateForInput = (dateStr) => {
        if (!dateStr) return '';

        // Если дата уже в формате YYYY-MM-DD
        if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return dateStr;
        }

        // Преобразуем из DD.MM.YYYY в YYYY-MM-DD
        if (dateStr.match(/^\d{2}\.\d{2}\.\d{4}$/)) {
            const [day, month, year] = dateStr.split('.');
            return `${year}-${month}-${day}`;
        }

        return '';
    };

    const renderInputField = () => {
        if (name === "Дата исполнения") {
            return (
                <div className="dateExecution">
                    <div className={"dateExecution__wrapper"}>
                        <div className={"dateExecution__wrapper__typeDate"}>
                            C:
                        </div>
                        <input
                            type="date"
                            value={formatDateForInput(filter)}
                            onChange={handleFilterChange3}
                            className="myInput"
                            id="dateStart"
                        />
                    </div>
                    <div className={"dateExecution__wrapper"}>
                        <div className={"dateExecution__wrapper__typeDate"}>
                            По:
                        </div>
                        <input
                            type="date"
                            value={formatDateForInput(filter2)}
                            onChange={handleFilterChange2}
                            className="myInput"
                            id="dateEnd"
                        />
                    </div>
                </div>
            );
        } else if (name === "Дата закрытия") {
            return (
                <input
                    type="date"
                    placeholder={name}
                    value={formatDateForInput(filter)}
                    onChange={handleFilterChange3}
                    className="myInput"
                    id="dateClose"
                />
            );
        } else {
            return (
                <input
                    type="text"
                    placeholder={name}
                    value={filter}
                    onChange={handleFilterChange}
                    onClick={toggleDropdown}
                    className="myInput"
                    style={{paddingRight: "1.5vw"}}
                />
            );
        }
    };

    return (
        <div className={`dropdown_wrapper ${dropdown_wrapper_modifikator}`}ref={dropdownRef}>
            <div className={`dropdown_header ${dropdown_header_modifikator}`}>
                <div className={`dropdown_name`}>{name}</div>
                <div className={"search_util_icons_container"}>
                    <HandySvg src={ArrowDropDown} onClick={toggleSortOrder} className="arrow_filters" />
                    <HandySvg src={broomstick} onClick={clearValueSelect} className="arrow_filters" />
                </div>
            </div>
            <div className={"dropdown"} onClick={()=>{setSelectedItem(null)}}>
                {renderInputField()}
                {isOpen && (name !== "Дата исполнения" && name !== "Дата закрытия") && (
                    <div className={"dropdown-content-wrapper"}>
                        <div className="dropdown-content">
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => {
                                    const displayValue = typeof item === 'object' ? (item.name || item.fio || 'Неизвестно') : item;
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => handleItemSelect(item)}
                                            className="dropdown-content-item"
                                        >
                                            {displayValue}
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="dropdown-content-item no-results">Совпадений не найдено</div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );

};

export default CustomSearch2;